import { render } from "./products-recently-viewed.vue?vue&type=template&id=87b05b5a"
import script from "./products-recently-viewed.vue?vue&type=script&lang=js"
export * from "./products-recently-viewed.vue?vue&type=script&lang=js"

import "./products-recently-viewed.scss?vue&type=style&index=0&lang=scss&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__